import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ContentWrapper, Panel } from '@checkmarx/cx-ui';
import GeneralSettingsForm from './generalSettingsForm';

@inject('translationsStore', 'windowsDomainsStore' )
@observer
class GeneralSettings extends Component {

    componentWillMount() {
        this.props.windowsDomainsStore.resetStore();    
    }
    
    render(){
        
        return(
            <ContentWrapper className='content-wrapper' dataCy={'general-settings-screen'}>
                <Panel className='content-left-hand'>
                    <div className='setting-title'>
                        {this.props.translationsStore.translate('GENERAL_SETTINGS_TITLE')}
                    </div>
                    <div className='setting-sub-title'>
                    {this.props.translationsStore.translate('GENERAL_SETTINGS_SUB_TITLE')}
                    </div>
                </Panel>
                <Panel className='content-right-hand'>
                     <GeneralSettingsForm />
                </Panel>        
            </ContentWrapper>    
        );
    }
}

export default GeneralSettings;



// WEBPACK FOOTER //
// ./src/components/generalSettings/index.jsx